const hasValue = (value) => value !== null && value !== undefined && String(value).trim() !== '';

export const normalizeTaxRate = (value, fallback = 0) => {
  if (!hasValue(value)) {
    return Number(fallback || 0);
  }

  const rate = Number(value);
  return Number.isFinite(rate) && rate >= 0 && rate <= 100 ? rate : Number(fallback || 0);
};

export const resolveTaxConfig = (source = {}, fallback = { name: 'Tax', rate: 0 }) => {
  const nameValue = source?.taxName ?? source?.tax_name ?? source?.name;
  const explicitRate = source?.taxRate ?? source?.tax_rate ?? source?.rate;
  const isInvoiceRecord = source && (
    'vehicle_id' in source || 'total_amount_charged' in source || 'final_amount_charged' in source
  );
  const rateValue = hasValue(explicitRate)
    ? explicitRate
    : !isInvoiceRecord
      ? source?.tax_amount
      : undefined;
  const name = String(nameValue ?? '').trim() || fallback.name || 'Tax';

  return {
    name,
    rate: hasValue(rateValue) ? normalizeTaxRate(rateValue, fallback.rate) : fallback.rate
  };
};

export const formatTaxRate = (rate) => normalizeTaxRate(rate)
  .toFixed(3)
  .replace(/\.?0+$/, '');

export const formatTaxLabel = (source = {}) => {
  const taxConfig = resolveTaxConfig(source);
  return `${taxConfig.name} (${formatTaxRate(taxConfig.rate)}%)`;
};

export const calculateTax = (amount, taxConfig) => {
  const taxableAmount = Math.max(0, Number(amount || 0) || 0);
  return Number((taxableAmount * (normalizeTaxRate(taxConfig?.rate) / 100)).toFixed(2));
};

export const getInvoiceAmountDue = (invoice = {}) => (
  invoice.amount_due !== null && invoice.amount_due !== undefined
    ? Number(invoice.amount_due || 0)
    : Number(invoice.final_amount_charged ?? invoice.total_amount_charged ?? 0) +
      Number(invoice.tax_amount || 0)
);
